module.exports = __webpack_public_path__ + "img/tuijianchapin.e1aab3dd.png";